import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const FILL_IN_THE_BLANKS_ACTIVITY_FRAGMENT = gql `
  fragment FillInTheBlanksActivityFragment on FillInTheBlanksActivity {
    rounds {
      steps {
        id
        answer
        optionalWord
        activityAudio: optionalAudio {
          audio {
            ...AssetFragment
          }
        }
        activityImage: optionalImage {
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default FILL_IN_THE_BLANKS_ACTIVITY_FRAGMENT;
